import { BRAND_ASSETS_BASE } from '@mi-front/ui';

/** DOM id of the static splash in index.html (kept until app bootstrap is ready). */
export const BOOT_SPLASH_ELEMENT_ID = 'mi-boot-splash';

/** CDN URL for the splash / boot logo image. */
export const SPLASH_LOGO_SRC = `${BRAND_ASSETS_BASE}/images/logo-new.png`;
